import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Buttons from "../../components/Button/Button";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CustomerDashboard from "../../components/CustomerDashboard/CustomerDashboard";
import "./Dashboard.scss";
import OrderRow from "../../components/Orderrow/Orderrow";
import { campaignData } from "../../store/action";
import Button from "../../components/Button/Button";

const Order = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const campaign = useSelector((state) => state.campaign.campaign);
  const dispatch = useDispatch();
  const [total, setTotal] = useState(0);
  let tempCampaign = [...campaign];

  const remove = (data, index) => {
    if (
      tempCampaign[index]?.variation ||
      tempCampaign[index]?.variation?.length
    ) {
      tempCampaign[index].variation = [];
    }
    tempCampaign[index].variation = [];
    tempCampaign[index].quantity = 0;
    tempCampaign[index].size = "";
    tempCampaign[index].colors = "";
    setredux();
    totCal();
  };

  const removeVar = (index, ind) => {
    tempCampaign[index].variation[ind].quantity = 0;
    tempCampaign[index].variation[ind].size = "";
    tempCampaign[index].variation[ind].colors = "";
    setredux();
    totCal();
  };

  const setredux = () => {
    dispatch(
      campaignData({
        campaign: tempCampaign,
      })
    );
  };

  useEffect(() => {
    totCal();
  }, [campaign]);

  const totCal = () => {
    var sum = [];
    campaign.map((data) => {
      data.colors &&
        data.size &&
        sum.push(Number(data.quantity) * Number(data.realprice));
      data?.variation?.length > 0 &&
        data.variation.map((variant) => {
          variant.colors &&
            variant.size &&
            sum.push(Number(variant.quantity) * Number(variant.realprice));
        });
    });
    if (sum.length) {
      setTotal(sum?.reduce((x, y) => x + y));
    } else {
      setTotal(0);
    }
  };
  // console.log("campaign==>", campaign);
  return (
    <div className="home">
      <div className="left">
        <CustomerDashboard />
      </div>
      <div className="right">
        <div className="order">
          <div className="order-left">
            <div className="head">
              <div>
                <h2>{t("add-product")}</h2>
              </div>
              <div>
                <Buttons
                  text={t("add-another")}
                  style={{ width: "135px", fontSize: "11px", height: "35px" }}
                  onClick={() => history.push("/campaign")}
                />
              </div>
            </div>
            <div className="tail">
              <table
                style={{ width: "100%", textAlign: "left" }}
                CELLSPACING="0"
                CELLPADDING="0"
              >
                <thead>
                  <tr>
                    <th style={{ paddingLeft: "10px" }}>{t("product")}</th>
                    <th>{t("color")}</th>
                    <th style={{ textAlign: "center" }}>
                      <div style={{ marginLeft: "-140px" }}>{t("size")}</div>
                    </th>
                    <th>{t("quantity")}</th>
                    <th>{t("price")}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <hr />
                    </td>
                    <td>
                      <hr />
                    </td>
                    <td>
                      <hr />
                    </td>
                    <td>
                      <hr />
                    </td>
                    <td>
                      <hr />
                    </td>
                    <td>
                      <hr />
                    </td>
                  </tr>
                  {campaign.map((data, ind) => {
                    return (
                      data.quantity !== 0 && (
                        <OrderRow
                          data={data}
                          index={ind}
                          remove={remove}
                          removeVar={removeVar}
                        />
                      )
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="order-right">
            <h3>{t("ord-sum")}</h3>
            {campaign.map((data, index) => {
              return data.quantity > 0 && data.colors && data.size ? (
                <div className="order-bottom">
                  <div className="gutter-bottom">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div>
                        <img
                          src={data.designShirt || data.designnimg}
                          width={80}
                          height={100}
                        />
                      </div>
                      <div>
                        <p style={{ marginLeft: "10px" }}>
                          <b>{data.shirtName || data.shirtname}</b>
                        </p>
                        <small>
                          <span
                            style={{
                              background: data.colors,
                              color: data.colors,
                            }}
                            className="col-box"
                          ></span>
                          <span>{data.size}</span>
                          <span>Qty:{data.quantity}</span>
                        </small>
                      </div>
                    </div>
                    <div style={{ textAlign: "right", marginTop: "25px" }}>
                      <DeleteOutlineOutlinedIcon
                        onClick={() => remove(data, index)}
                        className="cp"
                      />
                      <p>
                        <small>
                          <span>
                            Prix:
                            {Number(data.quantity) * Number(data.realprice)}€
                          </span>
                        </small>
                      </p>
                    </div>
                  </div>
                  {data?.variation?.length > 0 &&
                    data.variation.map((variant, ind) => {
                      // console.log(
                      //   "variant",
                      //   variant.designShirt || variant.designnimg
                      // );
                      return (
                        variant.quantity > 0 &&
                        variant.colors &&
                        variant.size && (
                          <div className="gutter-bottom">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <div>
                                <img
                                  src={
                                    variant.designShirt || variant.designnimg
                                  }
                                  width={80}
                                  height={100}
                                />
                              </div>
                              <div>
                                <p style={{ marginLeft: "10px" }}>
                                  <b>
                                    {variant.shirtName || variant.shirtname}
                                  </b>
                                </p>
                                <small>
                                  <span
                                    style={{
                                      background: variant.colors,
                                      color: variant.colors,
                                    }}
                                    className="col-box"
                                  ></span>
                                  <span>{variant.size}</span>
                                  <span>Qty:{variant.quantity}</span>
                                </small>
                              </div>
                            </div>
                            <div
                              style={{ textAlign: "right", marginTop: "25px" }}
                            >
                              <DeleteOutlineOutlinedIcon
                                onClick={() => removeVar(index, ind)}
                                className="cp"
                              />
                              <p>
                                <small>
                                  <span>
                                    Prix:
                                    {Number(variant.quantity) *
                                      Number(variant.realprice)}
                                    €
                                  </span>
                                </small>
                              </p>
                            </div>
                          </div>
                        )
                      );
                    })}
                </div>
              ) : null;
            })}
            {total > 0 && (
              <>
                <div className="checkout">
                  <p>
                    <b>Le Total:</b> {total}€
                  </p>
                </div>
                <div className="checkout-btn ">
                  <Buttons
                    text={t("checkout")}
                    onClick={() =>
                      history.push({
                        pathname: "/pay",
                        state: total,
                      })
                    }
                    style={{ width: "180px", marginBottom: "10px" }}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Order;
